export default{
	data(){
		return{
			// 加载
			loading:false,
			// 已完成课程列表
			oldPackage:[],
			// 每页显示条数
			pageSize: 5,
			// 当前页
			currentPage: 1,
			// 总页数
			total: 0,
		}
	},
	methods:{
		getData(){
			this.$post('learn_record/search',{
				token: this.$store.state.id,
				offset: (this.currentPage - 1) * this.pageSize,
				length: this.pageSize,
				learn_status: '已完成'
			}).then(res=>{
				this.oldPackage = res.data.result.data
				this.total = res.data.result.total
			})
		},
		
		// 每页的显示条数改变时调用
		handleSizeChange(pageSize) {
			this.pageSize = pageSize
			this.getData()
		},
		
		// 当前页改变时调用
		handleCurrentChange(currentPage) {
			this.currentPage = currentPage
			this.getData()
		},
		
		//跳转课程详情
		classDetails: function(id, is_project, purchased_id, categoryOrderId) {
		    let address = this.$router.resolve({
		        path: '/classstudy',
		        query: {
		            id: id,
		            purchased_id: purchased_id,
		            categoryOrderId: categoryOrderId
		        }
		    });
		    window.open(address.href, "_blank")
			// this.$toClass(id, is_project, purchased_id);
		},
	},
	created(){
		this.getData();
	}
}